import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT } from "@/lib/data";

export const WhatsAppFloat = () => (
  <motion.a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-chat-button"
    aria-label="Chat with us on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
    className="fixed bottom-5 left-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 transition-transform duration-200 hover:-translate-y-1 active:scale-95"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </motion.a>
);
